import React, { forwardRef } from "react";
import {cn} from "../../lib/utils"
const Input = forwardRef(({ label, name, className, type = "text", register, ...props }, ref) => {
  return (
    <div className="flex flex-col gap-1 mb-4">
      {label && (
        <label htmlFor={name} className="text-sm  font-medium text-neutral1000">
          {label}
        </label>
      )}
      <input
        id={name}
        name={name}
        type={type}
        className={cn(
          "flex h-11 w-full rounded-[8px] border border-gray-300 border-input bg-background px-3 py-2 text-sm text-neutral600 ring-offset-[#EFF8FF] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#101928] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...(register ? register(name) : {})} // Use `register` if provided
        {...props}
      />
    </div>
  );
});

Input.displayName = "Input";

export { Input };
